<template>
  <a
    :href="buttonUrl"
    target="_blank"
    :class="$style.base"
    :style="style"
  >
    {{ buttonTitle
        ? buttonTitle
        : $t('marketing.email.preview.button_message_default') }}
  </a>
</template>

<script lang="ts">
import { storeToRefs } from 'pinia';
import { defineComponent } from 'vue';
import { useMarketingStore } from '../../../store';

export default defineComponent({
  setup() {
    const { buttonTitle, buttonUrl, color, id } = storeToRefs(
      useMarketingStore(),
    );
    return {
      buttonTitle,
      buttonUrl,
      color,
      id,
    };
  },
  computed: {
    style() {
      let color = '#FD832D';
      if (this.color) {
        color = this.color;
      }
      return `background-color: ${color};`;
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (!this.buttonTitle) {
        this.buttonTitle = this.$t(
          'marketing.email.preview.button_message_default',
        );
      }

      if (!this.color && !this.id) {
        this.color = '#FD832D';
      }
    });
  },
});
</script>

<style
  lang="scss"
  module
>
.base {
  color: var(--color-text-inverted) !important;
  border-radius: $radius;
  padding: 22px $spacing * 3;
  margin: $spacing 0 0;
  background: var(--color-warning-light);
}
</style>
